import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-800 text-gray-300 py-8 mt-auto">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Company Info */}
                    <div className="space-y-4">
                        <h3 className="text-white font-semibold text-lg">Company</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link
                                    to="/why-us"
                                    className="hover:text-white transition-colors"
                                    tabIndex={0}
                                    aria-label="Why choose us"
                                >
                                    Why Us
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/about"
                                    className="hover:text-white transition-colors"
                                    tabIndex={0}
                                    aria-label="About us page"
                                >
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    className="hover:text-white transition-colors"
                                    tabIndex={0}
                                    aria-label="Contact page"
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div className="space-y-4">
                        <h3 className="text-white font-semibold text-lg">Legal</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link
                                    to="/terms"
                                    className="hover:text-white transition-colors"
                                    tabIndex={0}
                                    aria-label="Terms of service"
                                >
                                    Terms of Service
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/privacy"
                                    className="hover:text-white transition-colors"
                                    tabIndex={0}
                                    aria-label="Privacy policy"
                                >
                                    Privacy Policy
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Social Links */}
                    {/* <div className="space-y-4">
                        <h3 className="text-white font-semibold text-lg">Connect</h3>
                        <ul className="space-y-2">
                            <li>
                                <a 
                                    href="https://twitter.com/yourhandle"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-white transition-colors"
                                    tabIndex={0}
                                    aria-label="Twitter profile"
                                >
                                    Twitter
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="https://github.com/yourhandle"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-white transition-colors"
                                    tabIndex={0}
                                    aria-label="GitHub profile"
                                >
                                    GitHub
                                </a>
                            </li>
                        </ul>
                    </div> */}
                </div>

                {/* Copyright */}
                <div className="border-t border-gray-700 mt-8 pt-8 text-center">
                    <p className="text-sm">
                        © {currentYear} KeepItSorted. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};